import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../state/store';
import ExtAProvider from '../../extendedASSRM/components/extAProvider';
import AskV2Container from '../components/AskV2Container';
import AccessDeniedView from '../components/AccessDeniedView';
import AskV2ThemeProvider from '../theme/provider';

const AskVantageV2App: React.FC = () => {
  const companyDetails = useSelector((state: RootState) => state.company?.company_details as any);

  // company_id > 0 means Redux has been populated with real company data.
  // Until then, the access decision would be based on initial Redux defaults
  // (ask_vantage_v2_enabled: false), causing a flash of the access denied screen.
  const companyLoaded = (companyDetails?.company_id || 0) > 0;
  const isEnabled = Boolean(companyDetails?.ask_vantage_v2_enabled);

  if (!companyLoaded) return null;

  if (!isEnabled) {
    return (
      <AskV2ThemeProvider>
        <AccessDeniedView message="Ask Vantage is not enabled for your account. Please contact your administrator." />
      </AskV2ThemeProvider>
    );
  }

  return (
    <AskV2ThemeProvider>
      <ExtAProvider>
        <AskV2Container />
      </ExtAProvider>
    </AskV2ThemeProvider>
  );
};

export default AskVantageV2App;
